<template>
  <div class="users">
    <breadcrumbs :items="breadcrumbs">
      <select-field
          v-model="role"
          placeholder="Role"
          @input="filterByRole">
          <!-- <option value="all">All</option> -->
          <option v-for="option in roleOption" :value="option" :key="option.label">{{option.name}}</option>
      </select-field>
    </breadcrumbs>

    <rp-table
      name="users"
      :results="getUsers"
      :filter="selectedRole"
      :headings="[ 'name', 'email', {heading: 'Status', key: 'empty'}]"
      @rowClick="onRowClick">

      <div
        v-for="(user, index) in users"
        :key="index"
        :slot="'td-' + index + '-empty'">
        <rp-status :statusInfo="user.active" />
      </div>
    </rp-table>
  </div>
</template>

<script>
/* eslint-disable array-callback-return */
import Breadcrumbs from '@/components/Breadcrumbs'
import Table from 'raypro_ui/src/components/ui/Table'
import Status from 'raypro_ui/src/components/ui/Status'
import page from '@/mixins/page'
import SelectField from 'raypro_ui/src/components/ui/inputs/StyledSelect'

// API
import {getUsersByRole} from 'raypro_ui/src/api/users'
import {getRoles} from 'raypro_ui/src/api/roles'
import {errorMessages} from 'raypro_ui/src/api/error_messages'

export default {
  components: {
    Breadcrumbs,
    'rp-table': Table,
    'rp-status': Status,
    'select-field': SelectField
  },

  data() {
    return {
      users: [],
      roleOption: [],
      role: '',
      selectedRole: 'surgeon',
      page: {
        totalPages: 1,
        totalEntries: 0,
        pageSize: 10,
        pageNumber: 1,
        title: 'All Users'
      },
      breadcrumbs: [
        {label: 'Users Activation'}
      ]
    }
  },

  mounted() {
    getRoles().then(({data}) => {
      data.map((role) => {
        if(role.name !== 'patient') {
          return this.roleOption.push({
            label: role.name,
            value: role.id,
            name: role.name.charAt(0).toUpperCase() + role.name.slice(1)
          })
        }
      })
    })
  },

  mixins: [page],

  computed: {...errorMessages(['role'])},

  methods: {
    onRowClick(row) {
      this.$router.push(`/${row.role}s/${row.id}`)
    },

    filterByRole(e) {
      this.selectedRole = e.label
    },

    getUsers(page) {
      return getUsersByRole(page, this.selectedRole).then(({data, page}) => {
        // TODO: When API stops returning patients replace getUsersByRole
        const mapped = data.map((row) => {
          return {
            id: row.id,
            // salutation: row.profile.salutation,
            name: `${row.profile.first_name} ${row.profile.last_name}`,
            email: row.email,
            // speciality: row.profile.speciality,
            active: row.activated_at,
            role: row.roles[0].name
          }
        })

        this.users = mapped

        return {
          data: mapped,
          page
        }
      })
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.users
  .table
    box-shadow: $color-shadow

    .table-header, .table-row
      border-bottom: 1px solid $color-grey-light

    .status
      color: $color-text

  .breadcrumbs
    .right-items
      .input
        .input-wrapper
          select
            color: $color-text-invert
          .input-label
            color: $color-text-invert
        &.has-focus
          .arrow
            fill: $color-text-invert
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/Activation.vue